import React from "react";
import {Attribute} from "@/entity/Attribute";
import componentStyle from '@/styles/Component.scss';
import _ from "lodash";
import MButton from "./atom/MButton";
import {readByOCR} from "../api/card";

const AttributeEditor = ({
                           id,
                           edit = false,
                           showHeader = true,
                           attributes = [],
                           onChange = (attributes = []) => { },
                            showAutoReading = true,
                         }
) => {
  const updateAttribute = (newAttribute) => {
    onChange(
      _.sortBy(attributes.map((a) =>  { return (a.order === newAttribute.order) ? newAttribute : a})
      , 'order')
    )
  }

  const addAttribute = () => {
    onChange([...attributes, new Attribute({order: attributes.length + 1})])
  }
  const goUp = (index) => {
    const order = {}
    order[index] = index - 1
    order[index - 1] = index
    const ordered = swap(order)
    onChange(_.sortBy(ordered, 'order'))
  }

  const goDown = (index) => {
    const order = {}
    order[index] = index + 1
    order[index + 1] = index
    const ordered = swap(order)
    onChange(_.sortBy(ordered, 'order'))
  }

  const removeAttributes = (index) => {
    const newAttributes = _.filter(attributes, (a,i) => i !== (index-1))
    newAttributes.forEach((a, i) => {a.order = i})
    console.log(newAttributes)
    onChange(_.sortBy(newAttributes, 'order'))
  }

  const swap = (order = {}) => {
    const ordered = attributes.map((a) => {
      return new Attribute({...a, order: order[a.order] || a.order})
    })
    return _.sortBy(ordered, 'order')
  }

  const readFromOCR = async () => {
    const okToTrash = window.confirm('現在の入力を破棄してもよろしいですか？')
    if (!okToTrash) {
      return
    }
    const words = await readByOCR({ id })
    const attributes = _.map(words, (w, i) => { return new Attribute({ order: i, tag: '', value: w }) })
    onChange(attributes)
  }

  return (
    <>
      <div className={componentStyle.inputArea}>
        <table>
          {
            showHeader &&
            <thead>
            <tr>
              <th>見出し</th>
              <th>内容</th>
              <th></th>
            </tr>
            </thead>
          }
          <tbody>
          {
            attributes.map((attribute, i) => {
              return <React.Fragment key={attribute.order}>
                {
                  edit &&
                  <>
                    <tr>
                      <td>
                        <input type={'text'}
                               value={attribute.tag}
                               onChange={(e) => updateAttribute(new Attribute({...attribute, tag: e.target.value}))}
                               placeholder="見出しを入力してください。"/>
                      </td>
                      <td>
                        <input type={'text'}
                               value={attribute.value}
                               onChange={(e) => updateAttribute(new Attribute({...attribute, value: e.target.value}))}
                               placeholder="内容を入力してください。"/>
                      </td>
                      <td className={componentStyle.orderLine}>
                        <MButton value={'↑'} width={40} onClick={ () => goUp(attribute.order) } disabled={i === 0}></MButton>
                        <MButton value={'↓'} width={40} onClick={ () => goDown(attribute.order) } disabled={attribute.order === attributes.length}></MButton>
                        <MButton value={'X'} width={40} onClick={ () => removeAttributes(attribute.order) } />
                      </td>
                    </tr>
                  </>
                }
                {
                  !edit &&
                  <>
                    <tr>
                      <td>
                        {attribute.tag}
                      </td>
                      <td>
                        {attribute.value}
                      </td>
                      <td>
                      </td>
                    </tr>
                  </>
                }
              </React.Fragment>
            })
          }
          {
            edit &&
            <tr>
              <td></td>
              <td></td>
              <td>
                <MButton image={'tsuika.png'} value={'追加'} onClick={ addAttribute }></MButton>
                {showAutoReading &&
                  <MButton image={'jidouYomikomi.png'} value={'自動読込み'} onClick={ readFromOCR }></MButton>
                }
              </td>
            </tr>
          }
          </tbody>
        </table>
      </div>
    </>
  )
}
export default AttributeEditor
